import lazyScripts from "../services/lazy-scripts";
import radio from "../services/radio";
import http from "../services/http";

/**
 *
 * @param props
 * @return {{videoURL: null, mounted(): void}}
 */

export default (props) => {
    return {
        containerElement: null,
        videoElement: null,
        previewElement: null,
        volumeElement: null,
        overlayElement: null,
        seekerElement: null,
        seekerTimeout: 0,

        sources: {
            visible: false,
            default: {},
            available: {},
        },
        fullscreen: false,
        started: false,
        loaded: false,
        loading: false,
        finished: false,
        buffered: {
            length: 0,
            start: 0,
            end: 0,
            ratio: 0
        },
        paused: true,
        playing: false,
        initiated: false,
        switching: {
            active: false,
            time: 0,
        },
        muted: false,
        duration: {
            total: null,
            played: null,
            ratio: 0,
        },
        poster: null,
        preview: {
            breakpoints: [10,20,30,40,50,60,70,80,90,100],
            slices: [],
            duration: 0,
            current: 0,
            previous: -1,
            percentage: 0,
            url: null,
            time: null,
        },
        controls: {
            visible: false,
            timeout: 0,
        },
        arrows: {
            backwards: false,
            forwards: false,
        },

        hls: {
            native: false,
            supported: false,
            instance: null,
        },
        banner: {
            mobile: false,
            tablet: false,
            desktop: false,
        },
        bubbles: {
            index: 0,
            length: 0,
            interval: 0,
            timeout: 0,
            restartOne: 0,
            restartTwo: 0,
            time: {
                visible: 10000,
                hidden: 30000,
            },
            link: null,
            items: [],
            event ( delay = 0) {
                clearInterval(this.interval);
                clearTimeout(this.timeout);
                clearTimeout(this.restartOne);
                clearTimeout(this.restartTwo);
                this.length = this.items.length - 1;

                this.restartOne = setTimeout(() => {
                    this.roller();
                }, delay );

                this.restartTwo = setTimeout(() => {
                    this.interval = setInterval(() => {
                        this.roller();
                    }, this.time.hidden );
                }, delay + this.time.visible );
            },

            roller() {
                this.items.forEach((value, index) => {
                    value.visible = index === this.index;
                    value.active = index === this.index;
                    value.slideOut = false;
                });

                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.items[this.index].active = false;
                    this.items[this.index].slideOut = true;
                    // http.post(this.service.video.bubbles.track.view).then();

                    if ( this.index + 1 === this.length ) {
                        this.index = 0;
                    } else {
                        this.index ++;
                    }
                }, this.time.visible );
            },

            click() {
                // http.post(this.service.video.bubbles.track.click).then();
            }
        },
        preRoll: {
            link: false,
            media: false,
            element: null,
            available: false,
            started: false,
            finished: false,
            middle: false,
            muted: false,
            provider: null,
            progress: 0,
            skip: {
                show: false,
                remain: 5,
                delay: 5,
            },
            vast: {
                client: false,
                tracker: false,
                source: null,
            },
            hls: {
                native: false,
                supported: false,
            },
            ready() {

                this.element.addEventListener('timeupdate', () => {
                    this.progress = parseInt(this.element.currentTime / this.element.duration * 100);
                    if ( this.progress >= 50 && this.middle === false ) {
                        // console.log("middle");
                        this.vast.tracker.track('midpoint');
                        this.middle = true;
                    }
                    if ( this.element.currentTime >= this.skip.delay && this.skip.show === false ) {
                        this.skip.show = true;
                        return false;
                    }
                    if ( this.skip.show === false ) {
                        this.skip.remain = this.skip.delay - parseInt(this.element.currentTime);
                    }
                });

                this.element.addEventListener('ended', () => {
                    this.vast.tracker.complete();
                    this.available = false;
                    this.finished = true;
                    this.player();
                });

                if ( this.media.includes("m3u8") && Hls.isSupported()) {
                    let instance = new Hls();
                    instance.loadSource(this.media);
                    instance.attachMedia(this.element);
                    this.begin();
                } else {
                    this.element.src = this.media;
                    this.begin();
                }
            },
            begin () {
                this.vast.tracker.trackImpression();
                this.vast.tracker.track('start');
                this.started = true;
                this.element.play();
            },
            finish() {
                // console.log("Skip");
                this.vast.tracker.track('skip');
                this.element.pause();
                this.finished = true;
                this.player();
            },
            click() {
                // console.log("Click");
                this.vast.tracker.click();
            },
            player() {
                radio.emit("play");
            },
            mute() {
                this.muted = this.element.muted = !this.element.muted;
            },
            visible() {
                return this.started && !this.finished;
            }
        },



        postRoll: {
            link: false,
            media: false,
            element: null,
            available: false,
            started: false,
            finished: false,
            middle: false,
            muted: false,
            provider: null,
            progress: 0,
            skip: {
                show: false,
                remain: 5,
                delay: 5,
            },
            vast: {
                client: false,
                tracker: false,
                source: null,
            },
            hls: {
                native: false,
                supported: false,
            },
            ready() {
                radio.receive("play-post-roll", () => {
                    this.play();
                });
                this.element.addEventListener('play', () => {
                    this.vast.tracker.trackImpression();
                    this.vast.tracker.track('start');
                    this.started = true;
                });
                this.element.addEventListener('timeupdate', () => {
                    this.progress = parseInt(this.element.currentTime / this.element.duration * 100);
                    if ( this.progress >= 50 && this.middle === false ) {
                        // console.log("middle");
                        this.vast.tracker.track('midpoint');
                        this.middle = true;
                    }
                    if ( this.element.currentTime >= this.skip.delay && this.skip.show === false ) {
                        this.skip.show = true;
                        return false;
                    }
                    if ( this.skip.show === false ) {
                        this.skip.remain = this.skip.delay - parseInt(this.element.currentTime);
                    }
                });
                this.element.addEventListener('ended', () => {
                    this.vast.tracker.complete();
                    this.available = false;
                    this.finished = true;
                });

            },
            play() {
                if ( this.available && !(this.started || this.finished)) {
                    if ( this.media.includes("m3u8") && Hls.isSupported()) {
                        let PostHls = new Hls({
                            maxMaxBufferLength: 30,
                        });
                        PostHls.loadSource(this.media);
                        PostHls.attachMedia(this.element);
                        this.element.play();
                    } else {
                        this.element.src = this.media;
                        this.element.play();
                    }
                }
            },
            finish() {
                this.vast.tracker.track('skip');
                this.available = false;
                this.finished = true;
            },
            click() {
                this.vast.tracker.click();
            },
            mute() {
                this.element.muted = !this.element.muted;
            },
            visible() {
                return this.started && !this.finished;
            }
        },

        mounted() {

            this.preRoll.element = this.$refs.preRollElement;
            this.postRoll.element = this.$refs.postRollElement;

            this.videoElement = this.$refs.videoElement;
            this.previewElement = this.$refs.previewElement;
            this.seekerElement = this.$refs.seekerElement;
            this.volumeElement = this.$refs.volumeElement;
            this.overlayElement = this.$refs.overlayElement;
            this.containerElement = this.$refs.containerElement;

            // PreRoll Vast
            if ( this.service.preRoll.visible ) {
                this.preRoll.vast.source = this.service.preRoll.vast;
            }

            // PostRoll Vast
            if ( this.service.postRoll.visible ) {
                this.postRoll.vast.source = this.service.postRoll.vast;
            }

            this.bubbles.items = this.service.video.bubbles.items;
            this.bubbles.link = this.service.video.bubbles.link;
            this.bubbles.name = this.service.video.bubbles.name;

            this.banner.mobile = {
                iframe: this.service.banners.available.mobile.video_player,
                company: this.service.banners.company.mobile.video_player,
                provider: this.service.banners.provider.mobile.video_player,
            };
            this.banner.desktop = {
                iframe: this.service.banners.available.desktop.video_player,
                company: this.service.banners.company.desktop.video_player,
                provider: this.service.banners.provider.desktop.video_player,
            };

            this.videoElement.poster = this.service.player.poster;
            this.previewElement.src = this.service.player.preview.url;
            this.previewElement.load();

            lazyScripts.loadHls().then(() => {
                lazyScripts.loadVast().then(() => {
                    this.activate();
                    this.events();
                });
            });
        },
        activate() {

            this.hls.native = this.preRoll.hls.native = this.videoElement.canPlayType('application/vnd.apple.mpegURL') || this.videoElement.canPlayType('audio/mpegurl');
            this.hls.supported = this.preRoll.hls.supported = Hls.isSupported();

            // First check for native browser HLS support
            if ( this.service.player.sources.hls.length && ( this.hls.native || this.hls.supported)) {
                this.sources.available = this.service.player.sources.hls;
                // If no native HLS support, check if HLS.js is supported
                if (!this.hls.native) {
                    this.hls.instance = new Hls({
                        maxMaxBufferLength: 15,
                    });
                }
            } else {
                this.sources.available = this.service.player.sources.mp4;
            }

            Object.values(this.sources.available).forEach((source) => {
                if ( source.default ) {
                    this.sources.default = source;
                    if ( this.hls.instance) {
                        setTimeout(() => {
                            this.hls.instance.loadSource(source.link);
                            this.hls.instance.attachMedia(this.videoElement);
                        }, 500 );
                    } else {
                        this.videoElement.src = source.link;
                    }
                }
            });

            if ( this.preRoll.vast.source ) {
                //lazyScripts.loadVast().then(() => {
                    this.preRoll.vast.client = new VAST.VASTClient();
                    this.preRoll.vast.client.get( this.preRoll.vast.source ).then(res => {
                        if ( res.hasOwnProperty('ads') === false || res.ads.length === 0 ) {
                            return false;
                        }
                        this.preRoll.vast.tracker = new VAST.VASTTracker(this.preRoll.vast.client, res.ads[0], res.ads[0].creatives[0]);
                        this.preRoll.vast.tracker.load();
                        this.preRoll.vast.tracker.trackImpression();

                        this.preRoll.media = res.ads[0].creatives[0].mediaFiles[0].fileURL;
                        this.preRoll.link = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;
                        this.preRoll.available = true;

                        setTimeout(() => {
                            this.bunny.ready = true;
                            this.preRoll.ready();
                            this.videoElement.play();
                            this.videoElement.pause();
                        }, 250);
                    }).catch((e) => {
                        this.bunny.ready = true;
                        this.playPause();
                    });

                    this.postRoll.vast.client = new VAST.VASTClient();
                    this.postRoll.vast.client.get( this.postRoll.vast.source ).then(res => {
                        if ( res.hasOwnProperty('ads') === false || res.ads.length === 0 ) {
                            return false;
                        }
                        this.postRoll.vast.tracker = new VAST.VASTTracker(this.postRoll.vast.client, res.ads[0], res.ads[0].creatives[0]);
                        this.postRoll.vast.tracker.load();
                        this.postRoll.vast.tracker.trackImpression();
                        this.postRoll.media = res.ads[0].creatives[0].mediaFiles[0].fileURL;
                        this.postRoll.link = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;
                        this.postRoll.available = true;
                        setTimeout(() => {
                            this.postRoll.ready();
                        }, 250);
                    });
             //   });
            } else {
               this.bunny.ready = true;
               this.playPause();
            }
        },

        toggleMuted() {
            this.preRoll.mute();
            this.postRoll.mute();

            this.videoElement.muted = !this.videoElement.muted;
            this.muted = this.videoElement.muted;
            localStorage.setItem('bunny-muted', this.muted);
        },

        playPause() {
            // Track clicks
            if (!this.started) {
                fetch('/service/player-click.json').then(r => {});
                this.bubbles.event(5000);
            }
            if (this.paused) {
                this.started = true;
                this.paused = false;
                this.finished = false;
                this.hideControls();
                this.bubbles.event(5000);
                this.videoElement.play();
            } else {
                this.showControls();
                this.paused = true;
                this.videoElement.pause();
            }
        },

        volume(value) {
            this.videoElement.volume = value;
        },

        resume() {
            this.paused = false;
            this.videoElement.play();
        },

        showControls() {
            clearTimeout(this.controls.timeout);
            this.containerElement.dataset.active = "true";
            this.controls.visible = true;
        },

        hideControls( timeout = 3000) {
            clearTimeout(this.controls.timeout);
            this.controls.timeout = setTimeout(() => {
                this.containerElement.dataset.active = "false";
                this.previewElement.parentNode.style.display = 'none';
                this.sources.visible = false;
                this.controls.visible = false;
            }, timeout);
        },

        toggleSources() {
            if (this.sources.visible) {
                this.hideControls(0);
            } else {
                this.showControls();
            }
            this.sources.visible = !this.sources.visible;
        },

        changeSource(item) {
            if ( item.type === 'link') {
                window.location.href = item.link;
                return false;
            }

            this.sources.available.forEach((source) => {
                source.default = false;
            });

            item.default = true;
            this.sources.visible = false;
            this.switching = {
                active: true,
                time: this.videoElement.currentTime,
            };
            this.videoElement.pause();
            if ( this.hls.instance ) {
                this.hls.instance.loadSource(item.link);
                if ( (/android/.test(navigator.userAgent))) {
                    setTimeout(() => {
                        this.videoElement.currentTime = this.switching.time;
                        this.videoElement.play();
                    }, 100 );
                }
            } else {
                this.videoElement.src = item.link;
                this.videoElement.load();
            }
        },
        detectFullScreen() {
            return window.innerHeight === screen.height || ((screen.availHeight || screen.height-30) <= window.innerHeight);
        },
        makeFullScreen() {
            // Ios specific
            if ( this.videoElement.webkitEnterFullScreen && this.iOS()) {
                this.videoElement.webkitEnterFullScreen();
                return false;
            }

            if ( this.fullscreen === false ) {
                const requestFullScreen = this.containerElement.requestFullscreen || this.containerElement.webkitEnterFullScreen || this.containerElement.webkitRequestFullScreen || this.containerElement.mozRequestFullScreen || this.containerElement.msRequestFullScreen;
                requestFullScreen.call(this.containerElement);
                this.fullscreen = true;
            } else {
                const cancelFullScreen = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
                cancelFullScreen.call(document);
                this.fullscreen = false;
            }



        },

        iOS() {
            return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },

        events() {
            radio.receive("play", () => {
                this.playPause();
            });

            this.videoElement.addEventListener('canplay',() => {
                if ( this.switching.active ) {
                    this.videoElement.currentTime = this.switching.time;
                    if ( this.paused === false ) {
                        this.videoElement.play();
                    }
                    this.switching.active = false;

                }
            });

            this.videoElement.addEventListener('durationchange', () => {
                this.duration.total = this.toHHMMSS(this.videoElement.duration);
                this.duration.played = this.toHHMMSS(this.videoElement.currentTime);
                this.seekerElement.max = parseInt(this.videoElement.duration);
            });

            this.videoElement.addEventListener('loadedmetadata',() =>{
                this.duration.total = this.toHHMMSS(this.videoElement.duration);
                this.duration.played = this.toHHMMSS(this.videoElement.currentTime);
                this.loaded = true;
                this.seekerElement.max = parseInt(this.videoElement.duration);

                if (localStorage.getItem("bunny-volume") !== null ) {
                    this.videoElement.volume = parseFloat(localStorage.getItem("bunny-volume"));
                }
                if (localStorage.getItem("bunny-muted") !== null ) {
                    this.videoElement.muted = localStorage.getItem("bunny-muted") === 'true';
                    this.muted = this.videoElement.muted;
                }
                document.documentElement.style.setProperty('--bunny-volume', (this.videoElement.volume*100) + "%");

                if ( this.volumeElement ) {
                    this.volumeElement.value = this.videoElement.volume;
                }
            });

            let progress = [];

            this.videoElement.addEventListener('timeupdate', () => {
                if (!this.videoElement.paused ) {
                    this.duration.played = this.toHHMMSS(this.videoElement.currentTime);
                    this.duration.ratio = parseFloat(this.videoElement.currentTime / this.videoElement.duration * 100).toFixed(2)
                    this.seekerElement.value = this.videoElement.currentTime;
                    document.documentElement.style.setProperty('--bunny-ratio', this.duration.ratio + "%");
                    if (!this.hls.instance ) {
                        // this.buffered = {
                        //     length: this.videoElement.buffered.length,
                        //     start: this.videoElement.buffered.start(0),
                        //     end: this.videoElement.buffered.end(0),
                        //     ratio: parseFloat(this.videoElement.buffered.end(0) / this.videoElement.duration * 100).toFixed(2)
                        // };
                        // document.documentElement.style.setProperty('--bunny-buffer', this.buffered.ratio + "%");
                    }
                    if ( this.controls.visible && parseInt(this.videoElement.currentTime)%1 === 0 && !progress[parseInt(this.videoElement.currentTime)]) {
                        progress[parseInt(this.videoElement.currentTime)] = true;
                    }
                }
            });

            this.videoElement.addEventListener("seeked", (e) => {
                progress = [];
                this.bubbles.event(0);
            });

            this.videoElement.addEventListener("ended", () => {
                this.paused = true;
                this.finished = true;
                this.showControls();

                // Play the post-roll if available
                if ( this.postRoll.available ) {
                    this.postRoll.play();
                }
            });

            ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach((eventName) => {
                document.addEventListener(eventName, () => {
                    this.fullscreen = document.fullscreenElement !== null;
                    if (!this.fullscreen) {
                        this.showControls();
                        this.fullscreen = false;
                        this.paused = true;
                        this.videoElement.pause();

                    }
                });

            });

            this.videoElement.addEventListener("webkitendfullscreen", () => {
                setTimeout(() => {
                    this.showControls();
                    this.fullscreen = false;
                    this.paused = true;
                    this.videoElement.pause();

                }, 150);
            });

            this.videoElement.addEventListener('volumechange', (event) => {
                this.muted = this.videoElement.muted;

            });

            this.seekerElement.addEventListener('input', (event) => {
                this.videoElement.pause();
                document.documentElement.style.setProperty('--bunny-ratio', parseInt(event.target.value / this.videoElement.duration * 100 ) + "%");
                this.showControls();
                this.hideControls();
                clearTimeout(this.seekerTimeout);
                this.seekerTimeout = setTimeout(() => {
                    this.videoElement.currentTime = event.target.value;
                    this.paused = true;
                    this.playPause();
                }, 500 );
            });

            // Desktop only
            if ( this.volumeElement ) {
                this.volumeElement.addEventListener('input', (event) => {
                    this.volume(event.target.value);
                    localStorage.setItem('bunny-volume', event.target.value);
                    document.documentElement.style.setProperty('--bunny-volume', (this.videoElement.volume*100) + "%");
                });
            }

            // Calculate preview slices
            this.previewElement.addEventListener('canplay',  () => {
                for ( let i in this.preview.breakpoints ) {
                    if ( this.preview.breakpoints.hasOwnProperty(i)) {
                        this.preview.slices[i] = {
                            start: parseInt(i) !== 0 ? this.preview.breakpoints[i-1] : 0,
                            finish: this.preview.breakpoints[i],
                        };
                        this.preview.slices[i].seek = Math.round( (this.preview.slices[i].start + this.preview.slices[i].finish) / 2 * ( this.previewElement.duration/100 ));
                    }
                }
            });

            // Display the preview
            this.seekerElement.addEventListener('mousemove', (e) => {

                // Get DOMRect object
                let rectangle = e.target.getBoundingClientRect();

                // Mouse x position within the element.
                let position = e.clientX - rectangle.left;


                this.preview.percentage = Math.round( position * 100/  e.target.offsetWidth);

                this.preview.time = this.toHHMMSS( this.videoElement.duration * this.preview.percentage / 100 );

                for ( let i in this.preview.slices ) {
                    if ( this.preview.slices.hasOwnProperty(i) && this.preview.percentage > this.preview.slices[i].start && this.preview.percentage < this.preview.slices[i].finish ) {
                        this.preview.current = i;
                        break;
                    }
                }

                // Play only when breakpoint changes
                if ( this.preview.slices.length && this.preview.previous !== this.preview.current ) {
                    this.previewElement.currentTime = this.preview.slices[this.preview.current].seek;
                    this.previewElement.play();
                    this.preview.previous = this.preview.current;
                }

                // Position
                //e.target.offsetWidth

                let previewWidth = this.previewElement.clientWidth;
                let marginLeft = 0;
                if ( position < previewWidth/2 ) {
                    marginLeft = 0;
                } else {
                    marginLeft = position - previewWidth/2;
                }

                if ( position > e.target.offsetWidth - previewWidth/2 ) {
                    marginLeft = e.target.offsetWidth - previewWidth;
                }

                if (!this.device.mobile) {
                    this.previewElement.parentNode.style.display = 'flex';
                    this.previewElement.parentNode.style.left = marginLeft + 'px';
                }



                // console.log(marginLeft);
                // console.log("xxx", );
                // console.log(p);
            });

            // Pause the preview
            this.seekerElement.addEventListener('mouseleave', () => {
                this.previewElement.parentNode.style.display = 'none';
                this.previewElement.pause();
            });

            this.previewElement.addEventListener("timeupdate", () => {
                if ( this.previewElement.currentTime >=  this.preview.slices[this.preview.current].seek + 1 ) {
                    this.previewElement.pause();
                }
            });

            this.containerEvents();
            this.keyboardEvents();
            this.overlayEvents();

            if (!this.initiated) {
                //this.videoElement.load();
                this.initiated = true;
            }

        },

        containerEvents() {
            this.containerElement.dataset.active = "true";
            if (('ontouchstart' in document.documentElement)) {
                return false;
            }
            this.containerElement.addEventListener('mousemove', () => {
                if ( !this.paused && this.started ) {
                    this.showControls();
                    this.hideControls();
                }
            });

            this.containerElement.addEventListener('mouseleave', () => {
                if ( !this.paused && this.started ) {
                    this.hideControls();
                }
            });

        },
        keyboardEvents() {
            document.addEventListener('keydown', (event) => {
                if (event.target === document.body) {
                    switch (event.key) {
                        case " ":  event.preventDefault(); this.playPause(); break;
                        case "ArrowRight":  event.preventDefault();
                            this.seekerElement.value = parseInt(this.seekerElement.value) + 10;
                            this.seekerElement.dispatchEvent(new Event('input', { bubbles: true }));
                            break;
                        case "ArrowLeft":  event.preventDefault();
                            this.seekerElement.value = parseInt(this.seekerElement.value) - 10;
                            this.seekerElement.dispatchEvent(new Event('input', { bubbles: true }));
                            break;
                    }
                }
            });
        },
        overlayEvents() {
            let clicks = 0;
            this.overlayElement.addEventListener(('ontouchstart' in document.documentElement ? 'touchend' : 'click'), (event) => {
                event.preventDefault();
                if(!('ontouchstart' in document.documentElement)) {
                    if (++clicks === 1) {
                        setTimeout(() => {
                            // Single click
                            if(clicks === 1) {
                                this.playPause();
                            } else {
                                this.makeFullScreen();
                            }
                            clicks = 0;
                        }, 250);
                    }
                    return false;
                }

                let position = this.touchedPosition(event);
                let slice = this.overlayElement.offsetWidth / 3;
                if (++clicks === 1) {
                    setTimeout(() => {
                        // Single tap
                        if(clicks === 1) {
                            if (!this.controls.visible) {
                                this.showControls();
                                this.hideControls();
                            } else {
                                this.hideControls(250);
                            }
                        } else {
                            if ( position.x < slice) {
                                this.videoElement.currentTime = this.videoElement.currentTime - 10;
                                this.arrows.backwards = true;
                                setTimeout(() => {
                                    this.arrows.backwards = false;
                                }, 500);
                            }
                            if ( position.x > slice * 2) {
                                this.videoElement.currentTime = this.videoElement.currentTime + 10;
                                this.arrows.forwards = true;
                                setTimeout(() => {
                                    this.arrows.forwards = false;
                                }, 500);
                            }
                        }
                        clicks = 0;
                    }, 250);
                }
            });

        },
        touchedPosition(e) {
            if(e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
                let event = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
                let touch = event.touches[0] || event.changedTouches[0];
                return {
                    x: touch.pageX,
                    y: touch.pageY,
                }
            } else if (e.type === 'mousedown' || e.type === 'mouseup' || e.type === 'mousemove' || e.type === 'mouseover'|| e.type === 'mouseout' || e.type === 'mouseenter' || e.type === 'mouseleave') {
                return {
                    x: e.clientX,
                    y: e.clientY,
                }
            }
        },

        toHHMMSS ( sec_num ) {
            sec_num = parseInt(sec_num);
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            if ( sec_num >= 3600 ) {
                return hours+':'+minutes+':'+seconds;
            }
            return minutes+':'+seconds;
        },

    }
};
